import * as React from "react";
import { AppUrl } from "../../../config";
import { Link } from "react-router-dom";
import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

export interface Props {
  currentPageBreadCrumbTitle: string;
  resetState: (app: string) => void;
  currentApp: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  linkStyle: {
    "fontSize": "14px",
    "margin": "-12px auto 16px auto",
    "& a": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
      padding: "0px 5px",
    },
    "& a:focus, & a:hover": {
      color: "#BB3300",
      backgroundColor: "#E6F3FF",
    },
    "& a:active": {
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      textDecoration: "none",
    },
  },
}));

const links = (
  <>
    <a href="https://www.fdic.gov/">Home</a> &gt;
    <a href="https://www.fdic.gov/resources/">Resources</a> &gt;
    <a href="https://www.fdic.gov/resources/data-tools/">Data Tools</a>&gt;
  </>
);

const Breadcrumbs = ({
  currentPageBreadCrumbTitle,
  resetState,
  currentApp,
}: Props) => {
  const classes = useStyles();
  return (
    <>
      {currentPageBreadCrumbTitle !== "BankFind Suite" ? (
        <div id="breadcrumbs" className={classes.linkStyle}>
          {links}
          <Link
            to={AppUrl("HomePage")}
            onClick={() => {
              resetState(currentApp);
            }}
          >
            BankFind Suite
          </Link>
          &gt; {currentPageBreadCrumbTitle}
        </div>
      ) : (
        <div id="breadcrumbs" className={classes.linkStyle}>
          {links} {currentPageBreadCrumbTitle}
        </div>
      )}
    </>
  );
};

export default Breadcrumbs;
